<script lang="ts">
	import { scale } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';

	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import ScAuthority from './SCAuthority.svelte';
	import ScInfo from '../utils/SCInfo.svelte';
</script>

<div in:scale={{ duration: 250, delay: 0, opacity: 0.5, start: 0.98, easing: quintOut }}>
	<GradientBorder
		gradient="bg-fx-gradient-6"
		paddingClass="p-px"
		borderRadius="rounded-lg squircle-lg"
		outerClassList=" mb-4"
		innerClassList="bg-fx-gradient-8 p-4"
	>
		<ScAuthority />
		<ScInfo />
	</GradientBorder>
</div>
